import type { PlainDate } from "@sa-nu/shared-utils/date";

import { formatRoomsHeaderDateRange } from "./_utils/format-rooms-header-date-range";

type SiteDetailRoomsHeaderProps = {
  firstNight: PlainDate | null;
  lastNight: PlainDate | null;
};

/**
 * 拠点詳細モーダルの部屋タイプ一覧見出し。「予約可能な部屋」ラベルと選択中の日程・泊数を横並び表示する。
 * CombineDateInput と異なりアイコンを持たず、日程テキストは太字にしない（Figma node-id 7208:44469〜44472）。
 * firstNight/lastNight が null（真に日程未選択）のときは日程テキストを出さない。滞在期間フィルター
 * （date-filter-popup.tsx）も未選択時は日付を出さず「滞在期間」ラベルのみにする設計に揃えている。
 */
export function SiteDetailRoomsHeader({
  firstNight,
  lastNight,
}: SiteDetailRoomsHeaderProps) {
  const dateRangeLabel =
    firstNight !== null && lastNight !== null
      ? formatRoomsHeaderDateRange(firstNight, lastNight)
      : null;

  return (
    <div className="bg-dx-surface-base flex w-full items-start px-[16px] pt-[16px] pb-[8px]">
      <div className="flex flex-wrap items-center gap-x-[8px]">
        <p className="dx-headline-2-mobile text-dx-text-default">
          予約可能な部屋
        </p>
        {dateRangeLabel !== null && (
          <p className="dx-body-2 text-dx-text-default">{dateRangeLabel}</p>
        )}
      </div>
    </div>
  );
}
